import './css';
import './externalModules';
import moment from 'moment-timezone';
import {bootFontAwesome} from './fontawesome';
import {bootStore} from './store';
import {bootAPI} from './api';
import {bootGlobalApiErrorHandling} from './globalErrorHandling';
import {bootI18n} from './i18n';
import {createBrowserHistory} from 'history';
import {RouterStore, syncHistoryWithStore} from 'mobx-react-router';
import Store from '../stores/store';
import * as i18next from 'i18next';
import {MessageProvider} from '../i18n/i18n';
import 'typeface-open-sans';
import {bootGwtCommunication} from './GwtCommunications';

export const boot = async (): Promise<{store: Store; i18n: i18next.i18n}> => {
    const browserHistory = createBrowserHistory();
    const routerStore = new RouterStore();
    syncHistoryWithStore(browserHistory, routerStore);
    const i18n = await bootI18n();
    bootFontAwesome();
    moment.tz.setDefault('UTC');
    const messageProvider: MessageProvider = (key, options) => i18n.t(key, options);
    const store = bootStore(messageProvider, routerStore);
    bootAPI(store.logoutUser);
    const gwtCommunication = bootGwtCommunication(store);
    if (window !== window.parent) {
        gwtCommunication.startListen();
    }
    bootGlobalApiErrorHandling(messageProvider);
    return {store, i18n};
};



// WEBPACK FOOTER //
// ./src/boot/index.ts